import { Injectable } from '@angular/core';
import { Toastrservice } from './toastr.service';

@Injectable({
    providedIn: 'root'
})
export class ToastrMessage {
    constructor(private toastrService: Toastrservice) {

    }

    showSuccessToastr(message: string): void {
        this.toastrService.success(message, 'Success Message');
    }

    showWarningToastr(message: string): void {
        this.toastrService.warning(message, 'Warning Message');
    }

    showErrorToastr(message: string): void {
        this.toastrService.error(message, 'Error Message');
    }

    showInfoToastr(message: string): void {
        this.toastrService.info(message, 'Info Message');
    }

    showError_MsgToastr(error_Cd: string, error_Msg: string): void {
        this.toastrService.error(error_Cd + ": " + error_Msg, "Error Message");
    }

    showAddedItemToastr(typeName: string): void {
        this.toastrService.success(typeName + "(s) has been added successfully.", "Success Message");
    }

    showValiatedToastr(typeName: string): void {
        this.toastrService.success(typeName + " is successfully validated.", "Success Message");
    }

    showEmptyInvalidateToastr(typeName: string): void {
        this.toastrService.error("Empty " + typeName + " is invalid.", "Error Message");
    }

    showEmptyCutItemsToastr(typeName: string): void {
        this.toastrService.info("To cut, please select the " + typeName + "(s).", "Info Message");
    }

    showCutItemsToastr(typeName: string): void {
        this.toastrService.success(typeName + "(s) has been cut successfully.", "Success Message");
    }

    showEmptyCopyItemsToastr(typeName: string): void {
        this.toastrService.info("To copy, please select the " + typeName + "(s).", "Info Message");
    }

    showCopiedItemsToastr(typeName: string): void {
        this.toastrService.success(typeName + "(s) has been copied successfully.", "Success Message");
    }

    showEmptyClipboardToastr(typeName: string): void {
        this.toastrService.info("No " + typeName + "(s) are copied to the clipboard.", "Info Message");
    }

    showPastedItemsToastr(typeName: string): void {
        this.toastrService.success(typeName + "(s) has been pasted successfully.", "Success Message");
    }
    showErrorPastedItemsToastr(typeName: string): void {
        this.toastrService.info("Copied " + typeName + "(s) are not allowed to paste for different types of objects.", "Info Message");
    }

    showEmptyDeleteItemsToastr(typeName: string): void {
        this.toastrService.info("To delete, please select the " + typeName + "(s).", "Info Message");
    }

    showEmptyDeleteObjectsToastr(objectName: string): void {
        this.toastrService.info("To delete " + objectName + ", please select the atleast one object.", "Info Message");
    }
    generateCsvList(objectName: string): void {
        this.toastrService.warning("In " + objectName + ", Please select atleast one object to generate CSV file", "Info Message");
    }

    showDeletedItemsToastr(typeName: string): void {
        this.toastrService.success(typeName + "(s) has been deleted successfully.", "Success Message");
    }
    showUpdateGlossaryItemsToastr(typeName: string): void {
        this.toastrService.success("Business Glossary" + typeName + "Updated Successfully ", "Success Message");
    }
    showSaveGlossaryItemsToastr(typeName: string): void {
        this.toastrService.info("Please select one Attribute to generate " + typeName , "Info Message");
    }
    showResetGlossaryItemsToastr(typeName: string): void {
        this.toastrService.info("Please select Attribute to reset " + typeName, "Info Message");
    }
    showAfterResetGlossaryItemsToastr(typeName: string): void {
        this.toastrService.success("Attributes" + typeName + " are Reset Successfully ", "Success Message");
    }
    showSelectAllItemsToastr(typeName: string): void {
        this.toastrService.info("Please select All Attributes to generate " + typeName, "Info Message");
    }

    showSaveAllAttributeToastr(typeName: string): void {
        this.toastrService.info("Please select all Attributes to save " + typeName, "Info Message");
    }
    showSavedAttributeToastr(typeName: string): void {
        this.toastrService.success( typeName +" is Saved in Attributes", "Success Message");
    }
    showEmptyUpItemsToastr(typeName: string): void {
        this.toastrService.info("To move up, please select the " + typeName + "(s).", "Info Message");
    }

    showSelectUpItemsToastr(typeName: string): void {
        this.toastrService.info("Can't move up, it is already on top position " + typeName + "(s).", "Info Message");
    }

    showUpItemsToastr(typeName: string): void {
        this.toastrService.info(typeName + "(s) has been moved up successfully.", "Success Message");
    }

    showEmptyDownItemsToastr(typeName: string): void {
        this.toastrService.info("To move down, please select the " + typeName + "(s).", "Info Message");
    }

    showSelectDownItemsToastr(typeName: string): void {
        this.toastrService.info("Can't move down, it is already on last position " + typeName + "(s).", "Info Message");
    }

    showDownItemsToastr(typeName: string): void {
        this.toastrService.success(typeName + "(s) has been moved down successfully.", "Success Message");
    }

    showEmptyUnlinkItemsToastr(typeName: string): void {
        this.toastrService.info("To unlink, please select the " + typeName + "(s).", "Info Message");
    }

    showSelectedItemsAreAlreadyUnlinkedToaster(typeName: string): void {
        this.toastrService.info("Selected " + typeName + "(s) are already unlinked.", "Info Message");
    }

    showUnlinkedItemsToastr(typeName: string): void {
        this.toastrService.success(typeName + "(s) has been unlinked successfully.", "Success Message");
    }

    showUnlockObjectToastr(objectName: string): void {
        this.toastrService.success(objectName + "(s) has been unlocked successfully.", "Success Message");
    }

    showAutoMapToastr(typeName: string): void {
        this.toastrService.success(typeName + "(s) has been auto mapped successfully.", "Success Message");
    }

    showSaveToastr(objectName: string): void {

        this.toastrService.success(objectName + "(s) has been saved successfully.", "Success Message");
    }

    showRevertToastr(objectName: string): void {
        // DDS-9556
        // this.toastrService.success(objectName + "(s) has been reverted successfully.", "Success Message");
        this.toastrService.success("Changes to the " + objectName + " has been reverted successfully.", "Success Message");
    }

    showRefreshToastr(objectName: string): void {
        this.toastrService.success(objectName + "(s) has been refresh successfully.", "Success Message");
    }

    showRefreshError(objectName: string): void {
        this.toastrService.info(objectName + "(s) is not saved.", "Success Message");
    }

    showCloseToastr(objectName: string): void {
        this.toastrService.success(objectName + "(s) has been closed successfully.", "Success Message");
    }

    showDuplicateNameToastr(name: string): void {
        this.toastrService.warning(name + " is already exists.", "Warning Message");
    }

    showEmptyObjectOpenToastr(name: string): void {
        this.toastrService.info("To open " + name + "(s), please select atleast one object.", "Info Message");
    }

    showObjectOpenedInReadModeToastr(objectName: string, lockBy: string): void {
        let str: string = objectName + " is opened in read mode";
        if (lockBy != '') {
            str += " and locked by " + lockBy + ".";
        }
        this.toastrService.info(str);
    }

    showEmptyObjectCreateCopyToastr(objectName: string): void {
        this.toastrService.info("To create copy " + objectName + "(s), please select atleast one object.", "Info Message");
    }

    showEmptyObjectCreateAsTransientToastr(objectName: string): void {
        this.toastrService.info("To Copy as Transient " + objectName + "(s), please select atleast one object.", "Info Message");
    }

    showCreateCopyToastr(objectName: string): void {
        this.toastrService.success(objectName + "(s) has been created copy successfully.", "Success Message");
    }

    showEmptyObjectAssignGroupToastr(name: string): void {
        this.toastrService.info("To assign group name, please select atleast one object.", "Info Message");
    }

    //Export
    showEmptyExportObjectsToastr(objectName: string): void {
        this.toastrService.info("To export, please select the object(s)", "Info Message");
    }

    showOnlyOneSelectToastr(objectName: string): void {
        this.toastrService.info("To continue, please select one object.");
    }

    showUnsavedObjectFoundToastr(objectName: string): void {
        this.toastrService.info("Unsaved object(s) found, click SAVE or REVERT to continue.");
    }
}